import React from 'react'
import { Link } from 'react-router-dom'
import { HorizontalStack } from '@ztechapps/webui.util'
import type { PurchaseOrderStatusEnum, Vendor } from '@ztechapps/common.contract'
import { PurchaseOrderStatusBadge } from '../PurchaseOrderStatus/PurchaseOrderStatusBadge'

export type PurchaseOrderWidgetProps = {
  code: string
  vendor: Vendor
  status?: PurchaseOrderStatusEnum
  paymentStatus?: string
  linkTo?: string
}

export const PurchaseOrderWidget = ({ code, vendor, linkTo, status }: PurchaseOrderWidgetProps) => {
  const name = vendor?.company?.name ?? vendor?.profile?.name
  const codeComponent = <b>{code}</b>
  const linkComponent = linkTo ? <Link to={linkTo}>{codeComponent}</Link> : codeComponent

  return (
    <div>
      <HorizontalStack gap={1}>
        {linkComponent}
        <PurchaseOrderStatusBadge status={status} />
      </HorizontalStack>
      {!!name && <small>{name}</small>}
    </div>
  )
}
